import * as React from "react";

const IconTrash: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 12">
            <path
                fill="currentColor"
                d="M.75 10.875c0 .621.504 1.125 1.125 1.125h6.75c.621 0 1.125-.504 1.125-1.125V3h-9v7.875Zm6.375-6c0-.208.166-.375.375-.375s.375.167.375.375v5.25a.374.374 0 0 1-.375.375.374.374 0 0 1-.375-.375v-5.25Zm-2.25 0c0-.208.166-.375.375-.375s.375.167.375.375v5.25a.374.374 0 0 1-.375.375.374.374 0 0 1-.375-.375v-5.25Zm-2.25 0c0-.208.166-.375.375-.375s.375.167.375.375v5.25A.373.373 0 0 1 3 10.5a.373.373 0 0 1-.375-.375v-5.25Zm7.5-4.125H7.5L7.229.207A.375.375 0 0 0 6.893 0H3.607a.375.375 0 0 0-.335.207L3 .75H.375A.375.375 0 0 0 0 1.125v.75c0 .207.168.375.375.375h9.75a.375.375 0 0 0 .375-.375v-.75a.375.375 0 0 0-.375-.375Z"
            />
        </svg>
    );
};

export default React.memo(IconTrash);
